import request from 'utils/request'
import { MCAXS611InitRequest } from 'types/MCAXS611/MCAXS611InitRequest'

export const getMCAXS611InitRequest = (data: MCAXS611InitRequest) =>
  request({
    url: '/MCAXS611/init',
    method: 'post',
    data: data,
  })
